"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmEmail = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var ui_vector_graphic_1 = require("@hopin-team/ui-vector-graphic");

var react_1 = tslib_1.__importDefault(require("react"));

var ConfirmEmail = function ConfirmEmail(_a) {
  var title = _a.title,
      props = tslib_1.__rest(_a, ["title"]);

  return react_1.default.createElement(ui_vector_graphic_1.VectorGraphic, tslib_1.__assign({}, props, {
    title: title !== null && title !== void 0 ? title : 'Confirm Email',
    viewBox: "0 0 320 250",
    __UIScope: "ConfirmEmail"
  }), react_1.default.createElement("rect", {
    width: "320",
    height: "198",
    fill: ui_symbols_1.COLOR.GREY[100],
    opacity: "0.75",
    rx: "12"
  }), react_1.default.createElement("g", {
    filter: "url(#ConfirmEmail__filter0_d)"
  }, react_1.default.createElement("rect", {
    width: "272",
    height: "198",
    x: "24",
    y: "24",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("rect", {
    width: "34",
    height: "34",
    x: "31",
    y: "35",
    fill: ui_symbols_1.COLOR.BLUE[100],
    rx: "17"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.THEME.PRIMARY,
    fillRule: "evenodd",
    d: "M49.452 47.873c-.018.634-.458 1.534-1.197 1.534a.846.846 0 01-.845-.847 2.563 2.563 0 00-.863-1.851 2.56 2.56 0 00-1.426-.617 2.54 2.54 0 011.796-.759c.898 0 1.725.512 2.2 1.288.229.37.352.81.335 1.252zm-2.94.053c.387.493.634 1.48.07 1.957a.837.837 0 01-1.179-.106 2.577 2.577 0 00-1.848-.864 2.507 2.507 0 00-1.479.44 2.535 2.535 0 01.898-1.745 2.563 2.563 0 012.57-.423c.352.159.722.423.968.74zm-.915 3.385c.14-.723-.687-1.322-1.303-1.446a2.443 2.443 0 00-1.232.07 2.58 2.58 0 00-1.69 1.976 2.513 2.513 0 00.44 1.922c.141-.53.44-.988.845-1.305a2.6 2.6 0 011.972-.53.85.85 0 00.968-.687zm-1.76 1.464c.563-.3 1.566-.37 1.936.264a.85.85 0 01-.3 1.146 2.496 2.496 0 00-1.161 1.676 2.508 2.508 0 00.176 1.551 2.558 2.558 0 01-1.567-1.181 2.576 2.576 0 01.035-2.592 2.3 2.3 0 01.88-.864zm3.168 1.481c-.687-.247-1.426.44-1.655 1.04-.14.388-.193.812-.123 1.217.123.917.775 1.693 1.637 2.01.669.23 1.373.177 1.972-.106-.493-.229-.88-.6-1.127-1.058a2.53 2.53 0 01-.194-2.027.838.838 0 00-.51-1.076zm1.127 1.992c-.194-.599-.088-1.604.598-1.851a.841.841 0 011.074.494c.264.687.81 1.199 1.443 1.446a2.44 2.44 0 001.55.088 2.521 2.521 0 01-1.444 1.34 2.547 2.547 0 01-2.553-.494 2.72 2.72 0 01-.668-1.023zm2.006-2.874c-.37.653.194 1.481.74 1.816a2.34 2.34 0 001.179.336 2.576 2.576 0 002.27-1.27 2.564 2.564 0 00.247-1.957 2.511 2.511 0 01-1.25.934 2.595 2.595 0 01-2.042-.176.837.837 0 00-1.144.317zm2.165-.758c-.633.088-1.602-.194-1.725-.917a.855.855 0 01.687-.987 2.488 2.488 0 001.672-1.182c.264-.44.405-.97.352-1.516.546.37.95.952 1.074 1.657a2.57 2.57 0 01-.916 2.434c-.334.264-.739.458-1.144.511zM49.84 50.13c.563.476 1.479.07 1.9-.406.265-.3.459-.705.564-1.128a2.595 2.595 0 00-.862-2.451 2.5 2.5 0 00-1.884-.565c.387.388.616.882.704 1.393.106.67-.07 1.393-.528 1.975a.84.84 0 00.106 1.182z",
    clipRule: "evenodd"
  }), react_1.default.createElement("rect", {
    width: "34",
    height: "34",
    x: "31",
    y: "35",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "2",
    rx: "17"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "72",
    y: "37",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "21",
    height: "14",
    x: "152",
    y: "37",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "212",
    height: "8",
    x: "72",
    y: "59",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.BLUE[100],
    d: "M32 80a4 4 0 014-4h248a4 4 0 014 4v142H32V80z"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    d: "M56 116a4 4 0 014-4h200a4 4 0 014 4v106H56V116z"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "72",
    y: "127",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "168",
    height: "8",
    x: "72",
    y: "149",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "138",
    height: "8",
    x: "72",
    y: "165",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.BLUE[100],
    d: "M72 186a2 2 0 012-2h172a2 2 0 012 2v20a2 2 0 01-2 2H74a2 2 0 01-2-2v-20z"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.THEME.PRIMARY,
    d: "M124.931 192.341h-1.186l2.617 7.273h1.268l2.617-7.273h-1.186l-2.024 5.923h-.082l-2.024-5.923zM133.016 199.724c1.189 0 2.031-.586 2.272-1.474l-1.004-.181c-.192.515-.654.778-1.258.778-.909 0-1.519-.59-1.548-1.641h3.878v-.376c0-1.971-1.179-2.742-2.415-2.742-1.52 0-2.521 1.158-2.521 2.834 0 1.694.987 2.802 2.596 2.802zm-1.534-3.313c.042-.775.603-1.446 1.466-1.446.824 0 1.364.611 1.367 1.446h-2.833zM136.534 199.614h1.062v-3.331c0-.714.55-1.229 1.303-1.229.22 0 .469.039.554.064v-1.016a4.357 4.357 0 00-.451-.025c-.639 0-1.186.363-1.385.949h-.057v-.867h-1.026v5.455zM140.372 199.614h1.062v-5.455h-1.062v5.455zm.536-6.297c.366 0 .671-.284.671-.632 0-.348-.305-.635-.671-.635-.369 0-.671.287-.671.635 0 .348.302.632.671.632zM145.458 194.159h-1.175v-.49c0-.483.198-.746.717-.746.22 0 .376.05.476.082l.248-.859a2.538 2.538 0 00-.887-.146c-.863 0-1.62.504-1.62 1.527v.632h-.841v.852h.841v4.603h1.066v-4.603h1.175v-.852zM147.225 201.659c.877 0 1.431-.458 1.747-1.317l2.255-6.172-1.147-.011-1.382 4.233h-.056l-1.382-4.233h-1.136l1.996 5.526-.132.362c-.27.724-.65.785-1.232.625l-.256.87c.128.057.405.117.725.117zM154.874 199.614h1.062v-3.363c0-.735.515-1.247 1.118-1.247.59 0 .998.391.998.984v3.626h1.058v-3.477c0-.657.402-1.133 1.094-1.133.561 0 1.023.313 1.023 1.051v3.559h1.062v-3.658c0-1.246-.696-1.868-1.684-1.868-.784 0-1.374.376-1.637.959h-.056c-.238-.597-.739-.959-1.467-.959-.721 0-1.257.359-1.484.959h-.068v-.888h-1.019v5.455zM164.188 201.659c.877 0 1.431-.458 1.747-1.317l2.255-6.172-1.147-.011-1.382 4.233h-.056l-1.382-4.233h-1.136l1.996 5.526-.132.362c-.27.724-.65.785-1.232.625l-.256.87c.128.057.405.117.725.117zM174.188 199.724c1.189 0 2.031-.586 2.272-1.474l-1.005-.181c-.191.515-.653.778-1.257.778-.909 0-1.52-.59-1.548-1.641h3.878v-.376c0-1.971-1.179-2.742-2.415-2.742-1.52 0-2.521 1.158-2.521 2.834 0 1.694.987 2.802 2.596 2.802zm-1.534-3.313c.042-.775.603-1.446 1.466-1.446.824 0 1.364.611 1.367 1.446h-2.833zM177.706 199.614h1.062v-3.363c0-.735.515-1.247 1.118-1.247.59 0 .998.391.998.984v3.626h1.058v-3.477c0-.657.402-1.133 1.094-1.133.561 0 1.023.313 1.023 1.051v3.559h1.062v-3.658c0-1.246-.696-1.868-1.684-1.868-.784 0-1.374.376-1.637.959h-.056c-.238-.597-.739-.959-1.467-.959-.721 0-1.257.359-1.484.959h-.068v-.888h-1.019v5.455zM188.131 199.734c.902 0 1.41-.458 1.612-.866h.043v.746h1.037v-3.623c0-1.587-1.25-1.903-2.117-1.903-.987 0-1.896.398-2.251 1.392l.998.227c.156-.387.554-.76 1.268-.76.685 0 1.037.359 1.037.977v.025c0 .387-.398.38-1.378.493-1.034.121-2.092.391-2.092 1.63 0 1.073.806 1.662 1.843 1.662zm.231-.852c-.6 0-1.033-.27-1.033-.795 0-.569.504-.771 1.118-.853.345-.046 1.161-.138 1.314-.291v.703c0 .647-.515 1.236-1.399 1.236zM192.237 199.614h1.062v-5.455h-1.062v5.455zm.536-6.297c.366 0 .672-.284.672-.632 0-.348-.306-.635-.672-.635-.369 0-.671.287-.671.635 0 .348.302.632.671.632zM195.789 192.341h-1.062v7.273h1.062v-7.273z"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("filter", {
    id: "ConfirmEmail__filter0_d",
    width: "296",
    height: "222",
    x: "16",
    y: "12",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
};

exports.ConfirmEmail = ConfirmEmail;